





// vendor
import { defineComponent, ref, computed, PropType, onUnmounted, onBeforeMount } from "@vue/composition-api";
// project
import * as SessionAPI from "@/services/api/sessions";
import { Session } from "@/psychlab/types";
import { Dictionary } from "@/utils/types";
// local
import LiveTimer from "./live-timer.vue";

export default defineComponent({
	components:{
		LiveTimer
	},
	props:{
		session:{
			type:Object as PropType<Session>,
			required:true
		}
	},
	setup(props, context){

		const start = ref(new Date(props.session.created).getTime());
		const end = ref(props.session.expires);

		const stopped = computed(() => {
			return props.session.completed ? new Date(props.session.completed).getTime() : undefined;
		});
		
		return {
			start,
			end,
			stopped
		};
	}
});
